/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventFreeNftListEventFreeNftData model module.
 * @module model/EventsControllerDtoEventFreeNftListEventFreeNftData
 * @version 1.0
 */
class EventsControllerDtoEventFreeNftListEventFreeNftData {
    /**
     * Constructs a new <code>EventsControllerDtoEventFreeNftListEventFreeNftData</code>.
     * @alias module:model/EventsControllerDtoEventFreeNftListEventFreeNftData
     */
    constructor() { 
        
        EventsControllerDtoEventFreeNftListEventFreeNftData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventFreeNftListEventFreeNftData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventFreeNftListEventFreeNftData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventFreeNftListEventFreeNftData} The populated <code>EventsControllerDtoEventFreeNftListEventFreeNftData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventFreeNftListEventFreeNftData();

            if (data.hasOwnProperty('freenftNo')) {
                obj['freenftNo'] = ApiClient.convertToType(data['freenftNo'], 'Number');
            }
            if (data.hasOwnProperty('mintingCode')) {
                obj['mintingCode'] = ApiClient.convertToType(data['mintingCode'], 'String');
            }
            if (data.hasOwnProperty('issuedCount')) {
                obj['issuedCount'] = ApiClient.convertToType(data['issuedCount'], 'Number');
            }
            if (data.hasOwnProperty('usedCount')) {
                obj['usedCount'] = ApiClient.convertToType(data['usedCount'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('userCount')) {
                obj['userCount'] = ApiClient.convertToType(data['userCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventFreeNftListEventFreeNftData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventFreeNftListEventFreeNftData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['mintingCode'] && !(typeof data['mintingCode'] === 'string' || data['mintingCode'] instanceof String)) {
            throw new Error("Expected the field `mintingCode` to be a primitive type in the JSON string but got " + data['mintingCode']);
        }

        return true;
    }


}



/**
 * @member {Number} freenftNo
 */
EventsControllerDtoEventFreeNftListEventFreeNftData.prototype['freenftNo'] = undefined;

/**
 * @member {String} mintingCode
 */
EventsControllerDtoEventFreeNftListEventFreeNftData.prototype['mintingCode'] = undefined;

/**
 * @member {Number} issuedCount
 */
EventsControllerDtoEventFreeNftListEventFreeNftData.prototype['issuedCount'] = undefined;

/**
 * @member {Number} usedCount
 */
EventsControllerDtoEventFreeNftListEventFreeNftData.prototype['usedCount'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventFreeNftListEventFreeNftData.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventFreeNftListEventFreeNftData.prototype['endAt'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventFreeNftListEventFreeNftData.prototype['createdAt'] = undefined;

/**
 * @member {Number} userCount
 */
EventsControllerDtoEventFreeNftListEventFreeNftData.prototype['userCount'] = undefined;






export default EventsControllerDtoEventFreeNftListEventFreeNftData;

